import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="content" {...props} />;
}

export const meta = {
  id: 'CMSMenus',
  title: 'CMSMenus',
  category: 'CMS',
  exposes: [
    {
      title: 'CMS Menus',
      action: { module: 'CMSMenus', props: { /* */ } },
    },
    {
      title: 'Menu',
      action: { module: 'CMSMenusDetails', props: { context: 'add' } },
    },
  ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `Manages the menus for the CMS of a given tenant`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
